import React from "react";
import {SymbolsLeftTextFields} from "./AgSymbolsLeft";
import {useWebsocketStore} from "../../../stores/websocketStore/websocketProvider";
import {observer} from "mobx-react-lite";

const DisplaySymbolsLeft = observer(({}) => {
    const {symbolsLeftStore} = useWebsocketStore();
    return (
        <SymbolsLeftTextFields symbolsUsed={symbolsLeftStore.symbolsUsed} symbolsLeft={symbolsLeftStore.symbolsLeft}/>
    );
});

export default DisplaySymbolsLeft;
